import React, { useState } from 'react'
import { connect } from 'react-redux'
/// React router dom
import {Switch, Route, Redirect } from 'react-router-dom'
/// Css
import './index.css'

/// Layout
import Nav from './layouts/nav'
import Footer from './layouts/Footer'
import 'primeicons/primeicons.css'
import 'primereact/resources/themes/lara-light-indigo/theme.css'   // theme
import 'primereact/resources/primereact.css'                                 // icons
import 'primeflex/primeflex.css'

/// Dashboard
import Home from "./components/Dashboard/Home";
import PatientDetails from "./components/Patient/PatientDetails";
import PatientIdentify from "./components/Patient/Identify";
import PreIdentify from './components/Patient/PreIdentify';
import NumAssuIdentify from './components/Patient/NumAssuIdentify';
import AddConsultation from "./components/Consultation/AddConsultation";
import Administration from "./components/Administration/Administration";
import ClientRegistration from './components/Clients/ClientForm/ClientRegistration';
import ClientGroupRegistration from './components/Clients/ClientForm/ClientGroupRegistration';
import ClientsList from './components/Clients/ClientList/ClientsList';
import ClientSearch from './components/Clients/ClientSearch';
import ProviderList from './components/Providers/ProviderList/ProviderList';
import ProviderForm from './components/Providers/ProviderForm/ProviderForm';
import TarificationForm from './components/Providers/ProviderForm/TarificationForm';
import ProviderView from './components/Providers/ProviderView/ProviderView';
import ParametragePrestataire from './components/Providers/Parameter/Index';
import UserProfil from './components/UserProfil/UserProfil';
import NotificationsList from './components/Notifications/NotificationsList';
import AccordsList from './components/AccordPrealable/AccordPrealableList/AccordsList';
import AccordPreaView from './components/AccordPrealable/AccordPreaView/AccordPreaView';
import ConsultationList from './components/ConsultationList/ConsultationList';
import DetailsConsultation from './components/ConsultationViews/DetailsConsultation';
import DossierMedialPane from './components/DossierMedical/DossierMedialPane';
import FacturationDetails from './components/Facturation/FacturationDetails';
import FacturationList from './components/Facturation/FacturationList';
import RemboursementPane from './components/Remboursement/RemboursementForm/RemboursementPane';
import RemboursementRequest from './components/Remboursement/RemboursementForm/RemboursementRequest';
import RemboursementList from './components/Remboursement/RemboursementView/RemboursementList';
import RemboursementDetails from './components/Remboursement/RemboursementView/RemboursementDetails';
import RemboursementForm from './components/Remboursement/RemboursementForm/RemboursementForm';
import ProformasList from './components/AccordPrealable/ProformaList/ProformasList';
import ProformaView from './components/AccordPrealable/ProformaView/ProformaView';
import AnalyseConsommation from './components/Rapports/AnalyseConsommation';
import RapportsGlobal from './components/Rapports/RapportsPane';
import Monitoring from './components/Monitoring/Monitoring';
import HistoriqueAvenants from './components/Monitoring/HistoriqueAvenants';
import HistoriqueIdentification from './components/Monitoring/HistoriqueIdentification';
import PrestationList from './components/Prestations/PrestationList';
import PrestationDetails from './components/Prestations/PrestationDetails';
import PrestationForm from './components/Prestations/PrestationForm';
import CodesValidation from './components/Monitoring/CodesValidation';
import Synchronisation from './components/Monitoring/Synchronisation';
import EtatsPanel from './components/Rapports/Souscripteur/EtatsPanel';
import GeneralParameters from './components/GeneralParameters';
import PreEnroll from './components/Patient/PreEnroll';
import PartialEnroll from './components/Patient/PartialEnroll';
import ProformaKineView from './components/AccordPrealable/ProformaView/ProformaKineView';
import ProformasKineList from './components/AccordPrealable/ProformaList/ProformasKineList';
import Historique from './components/DemandesAvenant/Historique';
import Sinistres from './components/Sinistres/Sinistres';
import SinistresDeclares from './components/Sinistres/SinistresDeclares';
import Recours from './components/Sinistres/Recours';
import Evaluations from './components/Sinistres/Evaluations';
import Reglements from './components/Sinistres/Reglements';
import AssuresSearch from './components/Clients/AssuresSearch';
import FacturesPrestataireList from './components/Facturation/FacturesPrestataireList';
import FacturePrestataireDetails from './components/Facturation/FacturePrestataireDetails';
import PoliceDashboard from './components/Monitoring/DetailPolice';
import MissingDataSynchro from './components/Monitoring/MissingDataSyncro';
import MonitoringDashboard from './components/Monitoring/TrackPoliceTotalBene';
import BeneficiariesSync from './components/Monitoring/BeneficiariesSync';
import MainDashboard from './components/Monitoring/MainDashboard';
// import Reporting from './components/Reporting/Reporting'; // TODO: À créer

// Gestion Cartes Grouped Pages
import CartesGestionPage from './components/GestionCartes/CartesGestionPage';
import CartesProductionPage from './components/GestionCartes/CartesProductionPage';
import CardManagementCompletePage from './components/GestionCartes/CardManagementCompletePage';

// Gestion Contrats Module - TODO: À créer
// import {
//   ContratDashboard,
//   SouscripteursList,
//   SouscripteursListePage,
//   SouscripteurCreatePage,
//   SouscripteurDetailsPage,
//   ContratWizard,
//   ContratWizardComplete,
//   ModernContratWizard,
//   ContratWizardStep1,
//   ContratWizardStep2,
//   ContratWizardStep3,
//   ContratWizardStep4,
//   ContratWizardStep5,
//   ContratWizardStep6,
//   PolicesList,
//   PolicesListePage,
//   BeneficiairesImportWizard,
//   // BeneficiaireFamillePage,
//   // BeneficiairesRechercheAvancee,
//   TableauxPrestationsList,
//   TableauxPrestationsListModern,
//   CreateEditTableauForm,
//   TableauxTemplatesView,
//   AvenantsDashboard,
//   AvenantsList,
//   CreateAvenantWizard,
//   AvenantWorkflowManager,
//   RenouvellementManager,
//   IncorporationManager,
//   RetraitManager,
//   // Nouveaux composants modernes
//   AvenantsDashboardModern,
//   AvenantsListModern,
//   CreateAvenantWizardModern,
//   // Composants Polices Modernes
//   PolicesListModern,
//   PolicesCalendarView,
//   PolicesDashboardModern,
// } from './components/GestionContrat';
/// Pages
import Registration from './pages/Registration'
import Login from './pages/Login'
import LockScreen from './pages/LockScreen'
import Profile from './pages/Profile'
import Error403 from './pages/Error403'
import Help from './pages/Help'

//Scroll To Top
import ScrollToTop from './layouts/ScrollToTop';
import { currentUser } from '../store/selectors/CurrentUserSelector'
import CardClient from './components/Clients/CardClient'
import ExportFacture from './components/Facturation/ExportFacture'

import Chatbot from './pages/Chatbot';

// Gestion des Restrictions - TODO: À créer
// import RestrictionsMain from './pages/GestionRestrictions/RestrictionsMain';
// import RestrictionDashboard from './components/GestionRestrictions/RestrictionDashboard/RestrictionDashboard';
// import RestrictionsList from './components/GestionRestrictions/RestrictionsList/RestrictionsList';
// import CreateRestriction from './components/GestionRestrictions/RestrictionForm/CreateRestriction';

// Gestion des Enrollments - TODO: À créer
// import EnrollmentBatch from './components/GestionEnrollment/EnrollmentBatch';
// import EnrollmentList from './components/GestionEnrollment/EnrollmentList/EnrollmentList';
// import BeneficiaryList from './components/GestionEnrollment/BeneficiaryList';
// import UnifiedBeneficiaryProfile from './components/GestionEnrollment/UnifiedBeneficiaryProfile';
// import EnrollmentDashboard from './components/GestionEnrollment/EnrollmentDashboard';
// import EnrollmentIdentification from './components/GestionEnrollment/Identification/EnrollmentIdentification';
// Gestion des Cartes
import CardManager from './components/GestionCartes/CardManager/CardManager';

// Stock Management v2
import StockDashboard from './components/GestionCartes/StockManagement/StockDashboard';
import StockAlerts from './components/GestionCartes/StockManagement/StockAlerts';
import StockReports from './components/GestionCartes/StockManagement/StockReports';

// Template Editor
import TemplateEditorPage from './components/CarteV2/Templates/TemplateEditorPage';

const Markup = (props) => {
  let path = window.location.pathname
  path = path.split('/')
  path = path[path.length - 1]
  let pagePath = path.split('-').includes('page')
  const [activeEvent, setActiveEvent] = useState(!path)

  const routes = [
    /// Dashboard
    { url: "", component: Home },
    { url: "dashboard", component: Home },
	  { url: "patient-details", component: PatientDetails },
    { url: "patient-identify", component: PatientIdentify },
    { url: "patient-preidentify", component: PreEnroll },
    { url: "patient-enroll", component: PartialEnroll },
    { url: "identification", component: PreIdentify },
    { url: "identification-assure", component: NumAssuIdentify },
    { url: "consultation", component: AddConsultation },
    { url: 'client-register/:id/:updateMode', component: ClientRegistration },
    { url: 'client-group-register', component: ClientGroupRegistration },
    { url: 'client-list', component: ClientsList },
    { url: 'client-search', component: ClientSearch },
    { url: 'assure-search', component: AssuresSearch },
    { url: 'client-card/:id', component: CardClient },
    /// Prestataires
    { url: 'provider-list', component: ProviderList },
    { url: 'provider-form', component: ProviderForm },
    { url: 'tarification-form/:id', component: TarificationForm },
    { url: 'provider-update/:id', component: ProviderForm },
    { url: 'provider-view/:id', component: ProviderView },
    { url: 'provider-setting', component: ParametragePrestataire },
    /// pages
    { url: 'page-register', component: Registration },
    { url: 'page-lock-screen', component: LockScreen },
    { url: 'page-login', component: Login },
    { url: 'parametrage', component: Administration },
    { url: 'profile', component: Profile },
    { url: 'help-center', component: Help },
    // user profile
    { url: 'user-profil', component: UserProfil },
    
    /// Accords Préalables
    { url: 'accords-list', component: AccordsList },
    { url: 'demande-accord/:id/:idConsult', component: AccordPreaView },
    
    /// Notifications
    { url: 'notifications/:category', component: NotificationsList },

    /// Consultations
    { url: 'consultation-list', component: ConsultationList },
    { url: 'consultation-details/:id', component: DetailsConsultation },

    //Dossier Médical
    { url: 'dossier-medical/:id', component: DossierMedialPane },

    //Facturation
    { url: 'facturation', component: FacturationList },
    // { url: 'facturation', component: ExportFacture },
    { url: 'facturation-details/:id', component: FacturationDetails },
    { url: 'factures-prestataires', component: FacturesPrestataireList },
    { url: 'details-factures-prestataires/:code', component: FacturePrestataireDetails },

    //Remboursement
    { url: 'remboursement-form', component: RemboursementPane },
    { url: 'demande-remboursement', component: RemboursementRequest },
    { url: 'demande-remboursement-update/:id', component: RemboursementRequest },
    { url: 'remboursement-list', component: RemboursementList },
    { url: 'remboursement-update/:id', component: RemboursementForm },
    { url: 'remboursement-details/:id', component: RemboursementDetails },

    //Proformas Optique
    { url: 'proformas', component: ProformasList },
    { url: 'proforma-details/:id/:providerId', component: ProformaView },
    //Proformas Kine
    { url: 'proformas-kine', component: ProformasKineList },
    { url: 'proforma-kine-details/:id/:providerId', component: ProformaKineView },
    // Rapport
    { url: 'rapport-consommation', component: AnalyseConsommation},
    { url: 'rapport-global', component: RapportsGlobal},
    { url: 'etats-prestataires', component: EtatsPanel},
    // { url: 'reporting', component: Reporting}, // TODO: Composant Reporting à créer
    //Monitoring
    { url: 'monitoring', component: Monitoring},
    { url: 'historiques-avenants/:keyword/:currentData', component: HistoriqueAvenants},
    { url: 'codes-validation', component: CodesValidation},
    { url: 'historique-identifications', component: HistoriqueIdentification},
    { url: 'synchronisation', component: Synchronisation},
    { url: 'metric/police/:numPolice', component: PoliceDashboard},
    { url: 'metric/missing-data', component: MissingDataSynchro},
    { url: 'metric/police-diff', component: MonitoringDashboard},
    { url: 'metric/police-sync/beneficiaire', component: BeneficiariesSync},
    { url: 'monitoring/providers', component: MainDashboard},
    //Prestation
    { url: 'prestations', component: PrestationList},
    //{ url: 'prestation/:id', component: PrestationDetails},
    { url: 'prestation/:id', component: PrestationForm},
    //Error pages
    { url: 'access-denied', component: Error403 },
    //General Parameters
    { url: 'parametre-standarts', component: GeneralParameters},
    //Avenants
    {url: 'demandes-avenant', component: Historique},
    //Sinistres
    {url: 'sinistres', component: Sinistres},
    {url: 'sinistres-declares', component: SinistresDeclares},
    {url: 'recours', component: Recours},
    {url: 'evaluations', component: Evaluations},
    {url: 'reglements', component: Reglements},
    
    //Gestion des Restrictions - TODO: Composants à créer
    // {url: 'restrictions/dashboard', component: RestrictionDashboard},
    // {url: 'restrictions/list', component: RestrictionsList},
    // {url: 'restrictions/create', component: CreateRestriction},
    // {url: 'restrictions/view/:id', component: RestrictionsMain},
    // {url: 'restrictions/edit/:id', component: RestrictionsMain},
    // {url: 'restrictions/:view', component: RestrictionsMain},
    
    // Enrollment routes - TODO: Composants à créer
    // {url: 'enrollment/dashboard', component: EnrollmentDashboard},
    // {url: 'enrollment/batch', component: EnrollmentDashboard},
    // {url: 'enrollment/list', component: BeneficiaryList},
    // {url: 'enrollment/identification', component: EnrollmentIdentification},
    // {url: 'enrollment/patient-profile/:numeroAssure?', component: UnifiedBeneficiaryProfile},
    
    //Gestion Cartes - Grouped pages with tabs
    {url: 'cartes-gestion', component: CartesGestionPage}, // Operations: Suspension/Reactivation + Import + Error Management
    // {url: 'cartes-production', component: CartesProductionPage}, // Production: Quality Control + Stock Management
    // {url: 'cartes-suivi', component: CartesSuiviPage}, // Tracking: History + Business Rules Validation
    // {url: 'cartes/paiements', component: CartesPaiementsPage}, // Card Payments Management
    {url: 'cartes/gestion-complete', component: CardManagementCompletePage}, // Complete Card Lifecycle Management
    {url: 'cartes-v2/templates/:id/editor', component: TemplateEditorPage}, // Template Editor with ID
    {url: 'cartes-v2/templates/editor', component: TemplateEditorPage}, // Template Editor for new template

    // Stock Management v2 Routes
    // {url: 'stock-v2-dashboard', component: StockDashboard}, // Stock Dashboard with real-time data
    {url: 'stock-v2-alerts', component: StockAlerts}, // Stock Alerts and Thresholds Management
    // {url: 'stock-v2-reports', component: StockReports}, // Stock Reports and Analytics

    // Gestion Contrats Module Routes - TODO: Composants GestionContrat à créer
    // {url: 'contrats', component: ContratDashboard}, // Main dashboard
    // {url: 'contrats/dashboard', component: ContratDashboard}, // Design identique à Enrollment
    // {url: 'contrats/dashboard/analytics', component: PolicesDashboardModern}, // Analytics dashboard

    // // Souscripteurs
    // {url: 'contrats/souscripteurs', component: SouscripteursListePage},
    // {url: 'contrats/souscripteurs/create', component: SouscripteurCreatePage},
    // {url: 'contrats/souscripteurs/:id', component: SouscripteurDetailsPage},
    // {url: 'contrats/souscripteurs/:id/edit', component: SouscripteurCreatePage},

    // // Polices
    // {url: 'contrats/polices', component: PolicesListModern}, // Modern version with PrimeReact
    // {url: 'contrats/polices/dashboard', component: PolicesDashboardModern}, // Dashboard analytics
    // {url: 'contrats/polices/calendar', component: PolicesCalendarView}, // Calendar view
    // {url: 'contrats/polices/create', component: ModernContratWizard}, // Wizard moderne complet 5 étapes
    // {url: 'contrats/polices/create/individual', component: ModernContratWizard}, // Contrat individuel moderne
    // {url: 'contrats/polices/create/wizard', component: ModernContratWizard}, // Assistant Police moderne
    // {url: 'contrats/polices/create/step1', component: ContratWizardStep1}, // Wizard étape 1 seule
    // {url: 'contrats/polices/create/step2', component: ContratWizardStep2}, // Wizard étape 2 seule
    // {url: 'contrats/polices/create/step3', component: ContratWizardStep3}, // Wizard étape 3 seule
    // {url: 'contrats/polices/create/step4', component: ContratWizardStep4}, // Wizard étape 4 seule
    // {url: 'contrats/polices/create/step5', component: ContratWizardStep5}, // Wizard étape 5 seule
    // {url: 'contrats/polices/:id', component: PolicesListModern}, // Will handle details view
    // {url: 'contrats/polices/:id/edit', component: ModernContratWizard}, // Edit using modern wizard

    // // Bénéficiaires (disabled due to missing @mui/icons-material)
    // // {url: 'contrats/beneficiaires', component: BeneficiairesRechercheAvancee},
    // // {url: 'contrats/beneficiaires/liste', component: BeneficiairesRechercheAvancee},
    // {url: 'contrats/beneficiaires/import', component: BeneficiairesImportWizard},
    // // {url: 'contrats/beneficiaires/:id', component: BeneficiaireFamillePage},
    // // {url: 'contrats/beneficiaires/:id/famille', component: BeneficiaireFamillePage},

    // // Avenants - Versions modernes
    // {url: 'contrats/avenants', component: AvenantsDashboardModern},
    // {url: 'contrats/avenants/dashboard', component: AvenantsDashboardModern},
    // {url: 'contrats/avenants/list', component: AvenantsListModern},
    // {url: 'contrats/avenants/create', component: CreateAvenantWizardModern},
    // {url: 'contrats/avenants/create/renouvellement', component: RenouvellementManager},
    // {url: 'contrats/avenants/create/incorporation', component: IncorporationManager},
    // {url: 'contrats/avenants/create/retrait', component: RetraitManager},
    // {url: 'contrats/avenants/create/changement-college', component: CreateAvenantWizardModern},
    // {url: 'contrats/avenants/create/modification-garanties', component: CreateAvenantWizardModern},
    // {url: 'contrats/avenants/create/modification-dates', component: CreateAvenantWizardModern},
    // {url: 'contrats/avenants/:id', component: AvenantWorkflowManager},
    // {url: 'contrats/avenants/:id/edit', component: CreateAvenantWizardModern}, // Edit avenant
    // {url: 'contrats/avenants/:id/workflow', component: AvenantWorkflowManager},
    // {url: 'contrats/avenants/import', component: BeneficiairesImportWizard}, // Import avenants

    // // Import
    // {url: 'contrats/import/csv', component: BeneficiairesImportWizard}, // CSV Import wizard
    // {url: 'contrats/polices/export', component: PolicesListModern}, // Export polices
    // {url: 'contrats/polices/bulk-operations', component: PolicesListModern}, // Bulk operations

    // // Configuration
    // {url: 'contrats/configuration/tableaux', component: TableauxPrestationsListModern}, // Modern version
    // {url: 'contrats/configuration/tableaux/create', component: CreateEditTableauForm}, // Creation form
    // {url: 'contrats/configuration/tableaux/:id/edit', component: CreateEditTableauForm}, // Edit form
    // {url: 'contrats/configuration/tableaux/templates', component: TableauxTemplatesView}, // Templates view
  ]

  return (
       <> 
          <div
            id={`${!pagePath ? 'main-wrapper' : ''}`}
            className={`${!pagePath ? 'show' : 'mh100vh'}`}
          >
            {!pagePath && (
              <Nav
                onClick={() => setActiveEvent(!activeEvent)}
                activeEvent={activeEvent}
                onClick2={() => setActiveEvent(false)}
                onClick3={() => setActiveEvent(true)}
              />
            )}
            <div
              className={` ${!path && activeEvent ? 'rightside-event' : ''} ${
                !pagePath ? 'content-body' : ''
              }`}
            >
              <div
                className={`${!pagePath ? 'container-fluid' : ''}`}
                style={{ minHeight: window.screen.height - 60 }}
              >
                <Switch>
                  {routes.map((data, i) => (
                    <Route
                    key={i}
                    exact
                    
                    path={`/${data.url}`}
                    //element={ props.currentUser && props.currentUser.isFirstLogin ? <Redirect replace to="/profile#profile-settings" /> : <data.component /> }
                    //component={data.component}
                    >
                      { props.currentUser && props.currentUser.isFirstLogin && !data.url.includes('profile') ? 
                        <Redirect to="/profile#profile-settings" /> : 
                        <data.component /> 
                      }
                    </Route>
                  ))}
                </Switch>
              </div>
            </div>
            {!pagePath && <Footer />}
            <Chatbot />
          </div>
         <ScrollToTop />
       </>
  )
}
const mapStateToProps = (state) => {
    return {
       currentUser: currentUser(state)
    };
};
export default connect(mapStateToProps)(Markup);
